import { RouterModule } from "@angular/router";
import { PipesModule } from "../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PaginationComponent } from "./pagination/pagination.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./loader/loader.component";
import { SearchFormComponent } from "./search-form/search-form.component";
import { LengthAwarePaginatorComponent } from "./length-aware-paginator/length-aware-paginator.component";
import { SortByFieldComponent } from "./sort-by-field/sort-by-field.component";
import { PerPageComponent } from "./per-page/per-page.component";
import { CustomSelectionComponent } from "./custom-selection/custom-selection.component";
import { AutoresizeDirective } from "./autoresize/autoresize.directive";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule
  ],
  exports: [
    CustomSelectionComponent,
    LengthAwarePaginatorComponent,
    PerPageComponent,
    SearchFormComponent,
    SortByFieldComponent,
    PaginationComponent,
    LoaderComponent,
    AutoresizeDirective
  ],
  declarations: [
    CustomSelectionComponent,
    LengthAwarePaginatorComponent,
    PerPageComponent,
    SearchFormComponent,
    SortByFieldComponent,
    PaginationComponent,
    LoaderComponent,
    AutoresizeDirective
  ]
})
export class DirectivesModule {}
